import React from 'react';
import { Box } from 'grommet';
import { useSelector } from 'react-redux';

import { getSession } from 'src/reducers/workSessions/workSessionsSelectors';
import SessionProgressBar from 'src/scenes/work-sessions/components/SessionItemProgressBar';

export default function SessionProgress(): JSX.Element {
  const session = useSelector(getSession);

  return (
    <Box direction='row' gap='small' fill>
      <SessionProgressBar
        title='Work'
        itemOffset={0}
        itemDuration={session.workDurationSeconds}
        sessionDuration={session.durationSeconds}
      />
      <SessionProgressBar
        title='Break'
        itemOffset={session.workDurationSeconds}
        itemDuration={session.breakDurationSeconds}
        sessionDuration={session.durationSeconds}
      />
    </Box>
  );
}
